<template>
  <div class="app-detail-container">
    <div class="breadcrumbs mb-40">
      <div class="breadcrumb">
        <div class="btn-back color-black">
          <div class="container">
            <el-link class="font-16 font-w-bold" @click="handleBack">
              API Test Tool - {{ title }}
            </el-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-32">
      <el-row :gutter="60">
        <el-col :span="12">
          <el-form
            ref="refForm"
            :model="form"
            :rules="rules"
            label-position="top"
            style="max-width: 100%"
          >
            <div class="font-w-semi-bold font-18 mb-24">
              Request Parameters
            </div>
            <el-form-item label="URL" prop="endpoint">
              <el-input v-model="form.endpoint" />
            </el-form-item>
            <template v-for="(item, index) in dataTableRequest" :key="index">
              <div v-if="item.type !== 'file'">
                <el-form-item
                  :label="item.name"
                  :prop="'params.' + index + '.' + item.name"
                >
                  <el-input v-model="form.params[index][item.name]" :placeholder="item.type" />
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item
                  :label="item.name"
                  :prop="'params.' + index + '.' + item.name"
                >
                  <div class="custom-file-upload">
                    <input type="file" @change="onFileSelected">
                  </div>
                </el-form-item>
              </div>
            </template>
            <div v-if="title !== 'Token' && title !== 'Refresh Token'">
              <div class="font-w-semi-bold font-18 mt-28 mb-16">
                Headers
              </div>
              <el-form-item label="Access Token" prop="accessToken">
                <el-input type="text" v-model="form.accessToken" />
              </el-form-item>
            </div>
            <el-button
              :loading="loading"
              :disabled="disableRequest"
              type="success"
              class="btn-full-block"
              style="position: sticky; bottom: 0; z-index: 9;"
              @click="handleSendRequest">
              Send Request
            </el-button>
          </el-form>
        </el-col>
        <el-col :span="12">
          <div class="font-w-semi-bold font-18 mb-24">
            Response
          </div>
          <code-editor
            title="JSON"
            :data="dataResponseDynamic"
            @copyToClipboard="copyToClipboard"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script setup>
import { sendCollection, sendCollectionToken } from '@/api/endpoints/catalog/authOlsera.js'
import { dataCollection } from '@/api/endpoints/collection'
import { computed, onMounted, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import CodeEditor from '../components/_codeEditor.vue'
import useRequest from './useRequest.js'
import { useStore } from 'vuex'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const dataResponseDynamic = ref(null)
const title = ref(route.query.name)
// const url = ref(process.env.VUE_APP_BASE_API_URL)
const store = useStore()
const refForm = ref(null)
const form = reactive({
  accessToken: store.getters['app/testBearerToken'],
  endpoint: '',
  method: '',
  params: [],
  file: null
})

const apiBaseUrl = computed(() => {
  const prodUrl = process.env.VUE_APP_BASE_API_URL
  const stagUrl = 'https://api-open.all.olsera.indociti.com/'
  const isSandBox = store.getters['app/isSandbox']
  return isSandBox ? stagUrl : prodUrl
})

const disableRequest = computed(() => {
  if (title.value === 'Token' || title.value === 'Refresh Token') {
    if (
      form.endpoint &&
      form.method
    ) {
      return false
    } else {
      return true
    }
  } else {
    if (
      form.accessToken &&
      form.endpoint &&
      form.method
    ) {
      return false
    } else {
      return true
    }
  }
})

onMounted(() => {
  getDataCommon()
})

const {
  dataSelected,
  dataTableRequest
} = useRequest(dataCollection, route.query.name, false)

const rulesCollection = reactive({
  params: []
})

dataTableRequest.value.forEach((item, index) => {
  let isRequired
  if (item.required === 'required') {
    isRequired = true
  } else {
    isRequired = false
  }
  form.params[index] = {
    [item.name]: item.value
  }
  rulesCollection.params[index] = {
    [item.name]: [{ required: isRequired }]
  }
})

const rules = reactive({
  endpoint: [{ required: true }],
  accessToken: [{ required: true }],
  ...rulesCollection
})

const getDataCommon = () => {
  const baseUrl = apiBaseUrl.value.replace(/\/$/, '')
  const rawUrl = dataSelected.value.request?.url?.raw
  const formattedUrl = rawUrl.replace('{{url}}', baseUrl).split('?')[0]

  form.endpoint = formattedUrl
  form.method = dataSelected.value.request.method
}
const onFileSelected = (e) => {
  form.file = e.target.files[0]
}
const handleSendRequest = () => {
  loading.value = true
  const accesToken = form.accessToken
  const endpoint = form.endpoint
  const method = form.method
  let params = {}
  form.params.forEach(item => {
    for (const key in item) {
      if (item[key] === '' || item[key] === null) {
        delete item[key]
      }
    }
  })
  if (method === 'GET') {
    params = Object.assign({}, ...form.params)
  } else {
    params = new FormData()
    form.params.forEach(item => {
      for (const key in item) {
        if (key) {
          params.append(key, item[key])
        }
      }
    })
    if (form.file !== null) params.append('file', form.file)
  }
  const data = { accesToken, endpoint, method, params }
  if (title.value === 'token' || title.value === 'refresh token') {
    sendCollectionToken(data).then((response) => {
      dataResponseDynamic.value = response.data
      loading.value = false
    }).catch((error) => {
      ElMessage({
        type: 'error',
        message: error.message
      })
      dataResponseDynamic.value = error.string
      loading.value = false
    })
  } else {
    sendCollection(data).then((response) => {
      dataResponseDynamic.value = response.data
      loading.value = false
    }).catch((error) => {
      ElMessage({
        type: 'error',
        message: error.message
      })
      dataResponseDynamic.value = error.string
      loading.value = false
    })
  }
}
const copyToClipboard = (data) => {
  const response = jsonPretty(data)
  navigator.clipboard.writeText(response)
}
const jsonPretty = (json) => {
  return JSON.stringify(json, null, 4)
}
const handleBack = () => {
  router.go(-1)
}
</script>

<style lang="scss">
.el-form-item.is-required:not(.is-no-asterisk)>
.el-form-item__label-wrap>
.el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk)>
.el-form-item__label:before {
    display: inline-block !important;
}
.custom-file-upload {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: inline-block;
    padding: 12px;
    cursor: pointer;
}
</style>
